
@if (waitingForFilterResults) {
  <mat-progress-bar
    mode="indeterminate">
  </mat-progress-bar>
}

<br>

  <ag-grid-angular
    style="width: 100%; height: 200px;"
    class="ag-theme-balham"
    
    [rowData]="filteredAssessmentList"
    [columnDefs]="defaultUserViewCols"
    (gridReady)="onGridReady($event)"
    (cellClicked)="assessmentClicked($event)"
    >
  </ag-grid-angular>

  <br>
    <br>
      <br>



        @if (this.currentAssessment) {
          <div>
            <h2>{{ currentAssessment.entityType | titlecase }} &nbsp; Assessment</h2>
            <mat-grid-list cols="12" rowHeight="50px">
              <mat-grid-tile
                [colspan]=8
                [rowspan]=2>
                <mat-form-field class="full-width">
                  <input
                    matInput
                    required
                    placeholder="Name"
                    [(ngModel)]="currentAssessment.name"
                    name="name">
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile
                [colspan]=4
                [rowspan]=2>
                <mat-form-field class="full-width">
                  <mat-select placeholder="Type"
                    [disabled]="typeReadOnly"
                    (openedChange)="assessmentTypeSelectionChanged()"
                    [(ngModel)]="currentAssessment.type"
                    name="type">
                    @for (type of assessmentTypes; track type) {
                      <mat-option
                        [value]="type">
                        {{ type }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile
                [colspan]=4
                [rowspan]=1>
                <h4>Owner</h4>
              </mat-grid-tile>
              <mat-grid-tile
                [colspan]=4
                [rowspan]=1>
                <h4>Assessor</h4>
              </mat-grid-tile>
              <mat-grid-tile
                [colspan]=4
                [rowspan]=1>
                <h4>Final Reviewer</h4>
              </mat-grid-tile>
              <mat-grid-tile
                [colspan]=4
                [rowspan]=2>
                <p-autoComplete class="autocomplete-label" [(ngModel)]="currentAssessment.owner"
                  appendTo="body" name="owner" field="friendlyName" [suggestions]="filteredUsers"
                  (completeMethod)="filterUsers($event)"  [minLength]="1"
                  placeholder="type Last Name of user" [dropdown]="true">
                  <ng-template let-element pTemplate="item">
                    <span style="font-size:18px;font-weight: bold;">
                      {{element.friendlyName}}
                    </span>
                  </ng-template>
                </p-autoComplete>
              </mat-grid-tile>
              <mat-grid-tile
                [colspan]=4
                [rowspan]=2>
                <p-autoComplete class="autocomplete-label" [(ngModel)]="currentAssessment.assessor"
                  appendTo="body" name="assessor" field="friendlyName" [suggestions]="filteredUsers"
                  (completeMethod)="filterUsers($event)"  [minLength]="1"
                  placeholder="type Last Name of user" [dropdown]="true">
                  <ng-template let-element pTemplate="item">
                    <span style="font-size:18px;font-weight: bold;">
                      {{element.friendlyName}}
                    </span>
                  </ng-template>
                </p-autoComplete>
              </mat-grid-tile>
              <mat-grid-tile
                [colspan]=4
                [rowspan]=2>
                <p-autoComplete class="autocomplete-label" [(ngModel)]="currentAssessment.finalReviewer"
                  appendTo="body" name="finalReviewer" field="friendlyName" [suggestions]="filteredUsers"
                  (completeMethod)="filterUsers($event)"  [minLength]="1"
                  placeholder="type Last Name of user" [dropdown]="true">
                  <ng-template let-element pTemplate="item">
                    <span style="font-size:18px;font-weight: bold;">
                      {{element.friendlyName}}
                    </span>
                  </ng-template>
                </p-autoComplete>
                <!-- <p-dropdown
                name="finalReviewer"
                appendTo="body"
                [options]="listOfUsers"
                [(ngModel)]="currentAssessment.finalReviewer"
                (onChange)="getEntityData()"
                optionLabel="shortFriendlyName"
                optionValue="email">
              </p-dropdown> -->
            </mat-grid-tile>
            <mat-grid-tile
              [colspan]=4
              [rowspan]=2>
              <mat-form-field class="input-wide-width">
                <input
                  matInput
                  [matDatepicker]="criticalDatePicker"
                  placeholder="Critical Date"
                  [(ngModel)]="currentAssessment.criticalDate"
                  name="criticalDate">
                <mat-datepicker-toggle
                  matSuffix
                  [for]="criticalDatePicker">
                </mat-datepicker-toggle>
                <mat-datepicker
                  #criticalDatePicker>
                </mat-datepicker>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile
              [colspan]=4
              [rowspan]=2>
              <mat-form-field class="input-wide-width">
                <input
                  readonly="true"
                  matInput
                  placeholder="Source Record"
                  [(ngModel)]="currentAssessment.sourceRecord"
                  name="contractId">
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile
              [colspan]=4
              [rowspan]=2>
              Vendor/Party: &nbsp; &nbsp; <br><br>
              <b>{{ partyFriendlyName }}</b>
            </mat-grid-tile>
            <!-- <mat-grid-tile
            [colspan]=3
            [rowspan]=2>
            <a href="https://pstat-live-media.s3.amazonaws.com/pdf_cache/policy/13359549/9f2877cb-2dee-4f0a-84c9-92ac7c4255c4/Vendor%20Performance%20Evaluations.pdf">
              Vendor Assessment Policy
            </a>
          </mat-grid-tile> -->
          <mat-grid-tile
            [colspan]=4
            [rowspan]=2>
            <mat-form-field class="full-width">
              <mat-select
                placeholder="Status"
                (selectionChange)="assessmentStatusSelectionChanged()"
                [(ngModel)]="currentAssessment.status"
                name="status">
                @for (status of assessmentStatuses; track status) {
                  <mat-option
                    [value]="status">
                    {{ status }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile
            [colspan]=2
            [rowspan]=2>
            <!-- [disabled]="assessmentForm.invalid || statusUnchanged" -->
            @if (!waiting) {
              <button
                mat-raised-button color="primary"
                type="button"
                (click)="saveAssessment()"
                class="left-align">
                Save
              </button>
            }
          </mat-grid-tile>
          <mat-grid-tile
            [colspan]=6
            [rowspan]=2>
          </mat-grid-tile>
          <mat-grid-tile
            [colspan]=10
            [rowspan]=2>
            <mat-form-field class="full-width">
              <input
                matInput
                required
                placeholder="Quality Metrics Contract Location"
                [(ngModel)]="currentAssessment.qualityMetricsLocation"
                name="qualityMetricsLocation">
            </mat-form-field>
          </mat-grid-tile>
        </mat-grid-list>
        <br>
          <h3>Quality Metrics Contract Language Excerpt</h3>
          <p-editor
            [(ngModel)]="currentAssessment.qualityMetricsLanguageExcerpt"
            name="qualityMetricsLanguageExcerpt"
            [style]="{'height':'250px', 'width':'1200px'}">
            <p-header>
              <span class="ql-formats">
                <button class="ql-bold" aria-label="Bold"></button>
                <button class="ql-italic" aria-label="Italic"></button>
                <button class="ql-underline" aria-label="Underline"></button>
              </span>
            </p-header>
          </p-editor>
          <br>
            <br>
              <br>
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        Evaluation Instructions
                      </mat-panel-title>
                      <mat-panel-description>
                        Open to see instructions on how to do assessments
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div [innerHTML]="assessmentInstructions"></div>
                  </mat-expansion-panel>
                </mat-accordion>
                <br>
                  @if (waiting) {
                    <mat-spinner
                      >
                    </mat-spinner>
                  }
                  <br>
                    @if (scores && currentAssessment?.questionsAndAnswers) {
                      <div>
                        @for (questionAnswerObject of currentAssessment?.questionsAndAnswers; track questionAnswerObject; let i = $index) {
                          <mat-card appearance="outlined" class="questions-card"
                            >
                            <mat-card-header>
                              <mat-card-title>{{ questionAnswerObject.question }}</mat-card-title>
                            </mat-card-header>
                            @if (scores) {
                              <mat-card-content>
                                <!-- {{ questionAnswerObject | json }} -->
                                <mat-form-field style="width: 250px;">
                                  <mat-label>Choose a score</mat-label>
                                  <mat-select
                                    [(value)]="questionAnswerObject.score"
                                    (selectionChange)="onScoreChange($event.value, i)">
                                    @for (option of scores; track option; let index = $index) {
                                      <mat-option [value]="index">
                                        {{ option }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                                <br>
                                  <br>
                                  </mat-card-content>
                                }
                                <mat-card-actions>
                                  <mat-form-field class="example-full-width">
                                    <mat-label>Comment</mat-label>
                                    <textarea matInput
                                      [disabled]="readOnly"
                                      placeholder="Your comment" name="commenttextarea_{{i}}"
                                    [(ngModel)]="questionAnswerObject.comment"></textarea>
                                  </mat-form-field>
                                </mat-card-actions>
                              </mat-card>
                            }
                          </div>
                        }
                        <mat-divider></mat-divider>
                        <br>
                          <br>
                            <br>
                              <div>
                                <br>
                                  <b>Total Score: </b> &nbsp; &nbsp; <b>{{ totalScore }}</b>
                                  <br>
                                  </div>
                                  <br>
                                    <h3>Recommendations</h3>
                                    <p-editor
                                      [(ngModel)]="currentAssessment.recommendation"
                                      name="recommendation"
                                      [style]="{'height':'250px', 'width':'1200px'}">
                                      <p-header>
                                        <span class="ql-formats">
                                          <button class="ql-bold" aria-label="Bold"></button>
                                          <button class="ql-italic" aria-label="Italic"></button>
                                          <button class="ql-underline" aria-label="Underline"></button>
                                        </span>
                                      </p-header>
                                    </p-editor>
                                    <br>
                                      <mat-grid-list cols="12" rowHeight="50px">
                                        <mat-grid-tile
                                          [colspan]=4
                                          [rowspan]=2>
                                          <mat-form-field class="one-third-width">
                                            <mat-select
                                              placeholder="Status"
                                              (selectionChange)="assessmentStatusSelectionChanged()"
                                              [(ngModel)]="currentAssessment.status"
                                              name="status">
                                              @for (status of assessmentStatuses; track status) {
                                                <mat-option
                                                  [value]="status">
                                                  {{ status }}
                                                </mat-option>
                                              }
                                            </mat-select>
                                          </mat-form-field>
                                        </mat-grid-tile>
                                        <mat-grid-tile
                                          [colspan]=4
                                          [rowspan]=2>
                                          @if (!waiting) {
                                            <button
                                              mat-raised-button color="primary"
                                              type="button"
                                              (click)="saveAssessment()"
                                              class="left-align">
                                              Save
                                            </button>
                                          }
                                        </mat-grid-tile>
                                        <mat-grid-tile
                                          [colspan]=4
                                          [rowspan]=2>
                                        </mat-grid-tile>
                                      </mat-grid-list>
                                      @if (attestation) {
                                        <div>
                                          {{ attestation[0] }}
                                        </div>
                                      }
                                      <br>
                                        <br>
                                          <br>
                                            <mat-grid-list cols="12" rowHeight="50px">
                                              <!-- <mat-grid-tile
                                              [colspan]=2
                                              [rowspan]=1>
                                              <h2>View Contract</h2>
                                            </mat-grid-tile>
                                            <mat-grid-tile
                                              [colspan]=10
                                              [rowspan]=1>
                                            </mat-grid-tile> -->
                                            <mat-grid-tile
                                              [colspan]=2
                                              [rowspan]=2>
                                              @if (linkToContractFile) {
                                                <div>
                                                  <h3>View Contract</h3>
                                                  &nbsp; &nbsp;
                                                  <a target="_blank" href="{{linkToContractFile}}">
                                                    View Contract
                                                  </a>
                                                </div>
                                              }
                                              <!-- <button mat-button
                                              color="primary"
                                              (click)="goToContractLink()">
                                              View Contract
                                            </button> -->
                                          </mat-grid-tile>
                                          <mat-grid-tile
                                            [colspan]=10
                                            [rowspan]=2>
                                          </mat-grid-tile>
                                          <mat-grid-tile
                                            [colspan]=4
                                            [rowspan]=1>
                                            Your Sites
                                          </mat-grid-tile>
                                          <mat-grid-tile
                                            [colspan]=4
                                            [rowspan]=1>
                                            Status
                                          </mat-grid-tile>
                                          <mat-grid-tile
                                            [colspan]=4
                                            [rowspan]=1>
                                            Expiration Date
                                          </mat-grid-tile>
                                          <mat-grid-tile
                                            [colspan]=4
                                            [rowspan]=1>
                                            <b> {{ currentContract?.sitesNameDisplay }} </b>
                                          </mat-grid-tile>
                                          <mat-grid-tile
                                            [colspan]=4
                                            [rowspan]=1>
                                            <b> {{ currentContract?.status }} </b>
                                          </mat-grid-tile>
                                          <mat-grid-tile
                                            [colspan]=4
                                            [rowspan]=1>
                                            <b> {{ currentContract?.expirationDate | date:'shortDate' }} </b>
                                          </mat-grid-tile>
                                          <mat-grid-tile
                                            [colspan]=4
                                            [rowspan]=1>
                                            Contract Type
                                          </mat-grid-tile>
                                          <mat-grid-tile
                                            [colspan]=4
                                            [rowspan]=1>
                                            Your Departments
                                          </mat-grid-tile>
                                          <mat-grid-tile
                                            [colspan]=4
                                            [rowspan]=1>
                                            Renewal Type
                                          </mat-grid-tile>
                                          <mat-grid-tile
                                            [colspan]=4
                                            [rowspan]=1>
                                            <b> {{ currentContract?.type }}  </b>
                                          </mat-grid-tile>
                                          <mat-grid-tile
                                            [colspan]=4
                                            [rowspan]=1>
                                            <b> {{ currentContract?.departments }} </b>
                                          </mat-grid-tile>
                                          <mat-grid-tile
                                            [colspan]=4
                                            [rowspan]=1>
                                            <b> {{ currentContract?.renewalType }} </b>
                                          </mat-grid-tile>
                                        </mat-grid-list>
                                        <br>
                                          <br>
                                            <h3> Assessment History </h3>
                                            <br>
                                              <br>
                                                <ag-grid-angular
                                                  style="width: 80%; height: 200px;"
                                                  class="ag-theme-balham"
                                                  
                                                  [rowData]="allAssessmentsThisEntity"
                                                  [columnDefs]="assessmentHistoryColumns"
                                                  (gridReady)="onAssessmentHistoryGridReady($event)"
                                                  (cellClicked)='onAssessmentClickedHistoryGrid($event)'
                                                  >
                                                </ag-grid-angular>
                                                <br>
                                                  <br>
                                                    <h3> Click "View In New Tab" to see Attachment </h3>
                                                    <br>
                                                      <br>
                                                        <ag-grid-angular
                                                          style="width: 80%; height: 200px;"
                                                          class="ag-theme-balham"
                                                          
                                                          [rowData]="attachmentObjectArray"
                                                          [columnDefs]="attachmentColumns"
                                                          (gridReady)="attachmentGridReady($event)"
                                                          (cellClicked)='editAttachmentDialog($event)'
                                                          >
                                                        </ag-grid-angular>
                                                        <br>
                                                          <br>
                                                            <button
                                                              mat-raised-button color="primary"
                                                              (click)="openNewAttachmentDialog()">
                                                              Add New Attachment
                                                            </button>
                                                            <br>
                                                              <br>
                                                              </div>
                                                            }